import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../app/hooks";
import { selectCurrentUserToken, setToken } from "../features/auth/auth-slice";
import { DEFAULT_AUTH_SCHEME } from "../utils/auth-header.util";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const isLogged = useAppSelector(selectCurrentUserToken);
  const dispatch = useAppDispatch();
  const location = useLocation();
  if (!isLogged) {
    const expiration = localStorage.getItem("expiration");
    let token = localStorage.getItem("token");
    // Rehydrate the scheme from the SAME bucket the token came from so token
    // and scheme never split across stores. Defaults to Token for sessions
    // persisted before authScheme existed.
    let scheme = localStorage.getItem("authScheme") ?? DEFAULT_AUTH_SCHEME;
    if (expiration) {
      const expirationDate = new Date(parseInt(expiration));
      if (new Date().getTime() > expirationDate.getTime()) {
        token = null;
        localStorage.removeItem("token");
        localStorage.removeItem("expiration");
        localStorage.removeItem("authScheme");
      }
    } else {
      token = sessionStorage.getItem("token");
      scheme = sessionStorage.getItem("authScheme") ?? DEFAULT_AUTH_SCHEME;
    }
    if (token) {
      dispatch(setToken({ token, scheme }));
    } else {
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  }
  return children;
}
